<template>

    <div class="container-center">

        <el-form class="contract-form" label-width="140px" ref="form" :model="form" :rules="rules">

            <el-row>

                <el-col :span="7">
                    <el-form-item label="合同名称：" prop="name">
                        <el-input size="medium" v-model="form.contractName" clearable></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="7" :offset="1">
                    <el-form-item label="工程项目：" prop="region">
                        <el-input size="medium" v-model="form.projectName" clearable></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="7">
                    <el-form-item label="所属招标：" prop="region">
                        <el-input size="medium" v-model="form.tenderName" clearable></el-input>
                    </el-form-item>
                </el-col>

                <!--<el-col :span="7">-->
                    <!--<el-form-item label="合同状态：" prop="type">-->
                        <!--<el-select placeholder="请选择状态" size="medium" v-model="form.contractStatus">-->
                            <!--<el-option label="全部" value=""></el-option>-->
                            <!--<el-option label="待审批" value="0"></el-option>-->
                            <!--<el-option label="审批中" value="1"></el-option>-->
                            <!--<el-option label="审批通过" value="2"></el-option>-->
                            <!--<el-option label="审批不通过" value="3"></el-option>-->
                        <!--</el-select>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->

                <el-col :span="7">
                    <el-form-item label="履约保证金状态：" prop="type">
                        <el-select placeholder="请选择状态" size="medium" v-model="form.performanceStatus">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未缴纳" value="0"></el-option>
                            <el-option label="已缴纳" value="1"></el-option>
                            <el-option label="待退还" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>


                <el-col :span="3" :offset="2">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getContractList" icon="el-icon-search">搜索</el-button>
                </el-col>

            </el-row>

        </el-form>


        <div class="contract-list-box">

            <div class="no-data-tip" v-if="contractList.length == 0"></div>

            <!-- <div v-else class="contract-list" v-for="list in contractList">
                <div class="contract-list-calen">
                    <span class="big">{{(list.createDate||'0000-00-00 00:00:00').substring(8,10) }}</span>
                    <span>{{ (list.createDate||'0000-00-00 00:00:00').substring(5,7) }}月</span>
                    <span>{{ (list.createDate||'0000-00-00 00:00:00').substring(0,4) }}</span>
                </div>
                <div class="contract-list-info">
                    <p class="title">
                        <router-link :to="{name:'ContractSheet',params:{ id:list.fid }}" >{{list.fname}}</router-link>
                        <span class="status">
                            <span :title="list.approveStatus" v-bind:class="['state-cont'+ list.approveStatus]">{{ ['待审批','审批中','审批通过','审批不通过'][list.approveStatus] }}</span><br>
                            <span :title="list.performancePayment" v-bind:class="[''+ list.performancePayment]">履约保证金{{ ['未缴纳','已缴纳','待退还'][list.performancePayment] }}</span>
                        </span>
                    </p>
                    <p>
                        <span class="icon-no"  >合同编号：<font>{{ list.contractBillId }}</font></span>
                        <span class="icon-name">项目名称：<font>{{ list.projectname }}</font></span>
                    </p>
                    <p>
                        <span class="icon-type" >履约担保类型：<font>{{ list.performanceType }}</font></span>
                        <span class="icon-num"  >履约担保金额：<font>{{ list.performance }}</font></span>
                    </p>
                </div>
            </div> -->
            <el-table v-else :data="contractList || []" size="mini" border stripe>
                <el-table-column align="center" width="160"  label="合同名称" prop="fname">
                    <template slot-scope="scope">
                        <label class="fname">{{scope.row.isTransfer === '0'?'已转办':scope.row.isTransfer === '1'?'转办给我':''}}</label>
                        <span>{{scope.row.fname}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="160" label="合同编号" prop="contractBillId"></el-table-column>
                <el-table-column align="center" width="160" label="工程项目" prop="projectname">
                    <template slot-scope="scope">
                        {{scope.row.isTransfer != '1'?scope.row.projectname : ''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="合同含税金额" prop="taxPrice" >
                     <template slot-scope="scope">
                        {{scope.row.isTransfer != '1'?scope.row.taxPrice : ''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" width="100" label="签约时间" prop="fsigndate" >
                     <template slot-scope="scope">
                        {{scope.row.isTransfer != '1'?scope.row.fsigndate : ''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="履约担保类型" prop="performanceType" >
                     <template slot-scope="scope">
                        {{scope.row.isTransfer != '1'?scope.row.performanceType : ''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="履约担保金额" prop="performance" >
                     <template slot-scope="scope">
                        {{scope.row.isTransfer != '1'?scope.row.performance : ''}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="履约担保金状态">
                    <template slot-scope="scope">
                        <template v-if="scope.row.isTransfer !== '1'">
                            <span :title="scope.row.performancePayment">
                                {{ ['未缴纳', '已缴纳', '待退还'][scope.row.performancePayment] }}
                            </span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="合同状态">
                    <template slot-scope="scope">
                        <span :title="scope.row.approveStatus">
                            {{ ['待审批','审批中','审批通过','审批不通过'][scope.row.approveStatus] }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="200" label="操作">
                    <template slot-scope="scope">
                        <span class="contract-action">
                            <el-button type="text" v-if="scope.row.isTransfer == '0'" @click="resetTransfer(scope.row)">重新转办</el-button>
                            <el-button type="text" v-if="scope.row.isTransfer == '0'" @click="cancelTransfer(scope.row)">取消转办</el-button>
                            <el-button type="text" v-if="!scope.row.isTransfer" @click="transferSupplier(scope.row)">转办</el-button>
                            <el-button type="text" @click="goToDetail(scope.row)">查看</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>

        </div><!-- .contract-list-box -->


        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>

        <Transfer-supplier :visible="visible" :supplierList="supplierList" :info="info" @update="getContractList" v-if="visible.isShow"/>




    </div><!-- container-center -->

</template>

<script>

import banner from '@/assets/imgs/banner_inviteMng.png'
import TransferSupplier from './transferSupplierDialog'
import util from '@/util'

export default {
    name: 'contract-list',
    components:{ TransferSupplier },
    data () {
        return {
            rules: {

            },
            supplierList: [],
            contractList: [],

            form: {
                contractName: '',
                projectName: '',
                tenderName: '',
                contractStatus: '',
                performanceStatus: ''
            },
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            visible:{
                isShow:false,
            },
            info:{}

        }
    },
    methods: {
        getContractList () {
            const loading = this.$loading({ background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/contract/contractList',
                Object.assign(
                    {
                        supplierId: this.$root.stockId,
                        pageNum: this.pager.pageNum,
                        pageSize: this.pager.pageSize
                    },
                    this.form
                )
            ).then((res)=>{
                loading.close();
                if(res.data.result) {
                    this.contractList = res.data.value.list;
                    this.pager.total = res.data.value.count;
                    this.pager.pageNum = res.data.value.pageNo;
                } else {
                    this.$message({message: 'Error: 合同列表', type: 'error'})
                }
            })
        },
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getContractList();
        },

        transferSupplier(row){
            this.info = {
                rate:row.rate || '',
                fid:row.fid
            }
            this.visible.isShow = true;
        },

        resetTransfer(row){
            this.info = {
                rate:row.rate || '',
                fid:row.fid,
                supplierId:row.supplierId
            }
            this.visible.isShow = true;
        },

        cancelTransfer(row){
            this.$confirm('是否确认取消转办?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // type: 'warning'
            }).then(() => {
                 this.$http.post('rest/api/contract/cancelSupplier',{fid:row.fid}).then(data =>{
                     this.$message.success(data.data.message || '操作成功');
                     this.getContractList();
                 })
            })
        },
        goToDetail (data) {
            this.$router.push({name:'ContractSheet', params:{ id: data.fid }})
        },
        getSupplierList () {
            if (this.$root.stockId) {
                this.$http.post('rest/api/contract/getSupplierList',{supplierId: this.$root.stockId}).then(data =>{
                    this.supplierList = data.data.value || [];
                })
            }
        },
    },
    created(){
        this.$root.navs = [{name:'合同业务列表',path:'/contractList'}]
        this.$root.headImage.src = banner
        this.$root.activeIndex = 'home'
        this.$root.isPublic = false
        this.getSupplierList()
    },
    mounted () {
        util.hasIdCardNullFlag(this)
        this.getContractList();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';


.contract-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}
.contract-list {width:100%;padding:24px 0;border-bottom:1px solid #E4E5E4;}


/* 日历日期 */
.contract-list-calen {width: 92px;height: 92px;border: 1px solid #DDDEDD;display:inline-block;vertical-align:top;}
.contract-list-calen > span {display: block;font-size: 14px;padding: 1px 10px;}
.contract-list-calen > span.big {color: var(--cMain);line-height: 32px;font-size: 32px;padding-top: 10px;padding-bottom: 4px;}

.contract-list-info {margin-left: 40px;display:inline-block;}
.contract-list-info > p {margin: 0 0 12px 0;colors: #000;font-size: 14px;}
.contract-list-info > p.title {font-size: 18px;font-weight: bold;width:1000px;margin-bottom:20px;}
.contract-list-info > p.title .status {color:var(--cMain);float:right;text-align:right;font-size:14px;}
.contract-list-info > p.title a {color: #000;text-decoration: none;}
.contract-list-info > p.title a:hover {color: var(--cMain);}
.contract-list-info > p > span[class^=icon] {display: inline-block;width:360px;color: #646464;padding-left: 22px;height: 15px;line-height: 16px;background: url("") no-repeat center left;}
.contract-list-info > p > span font {color:#000;}
.contract-list-info > p > span.icon-no {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjMzODc3NDYwMjExODExRThBRDVCQ0ZDN0FEN0ZGNzkzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjMzODc3NDYxMjExODExRThBRDVCQ0ZDN0FEN0ZGNzkzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzM4Nzc0NUUyMTE4MTFFOEFENUJDRkM3QUQ3RkY3OTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzM4Nzc0NUYyMTE4MTFFOEFENUJDRkM3QUQ3RkY3OTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6+iJP7AAABYUlEQVR42kyQK87CUBCFabmUh4SmDlcMBkWQrKECg8KxhsouoJpFoFF1hARDgoMEi0ECaXhD/68cxD/i3nmec2asLMuSJFmtVo/Hw7KsQqHw+Xxs2+YNgqDT6ZB5Pp+lUsmQWq/X4/G4Xq8zRoF3uVxuNpv5fH48Hvv9Pn3v99umdr/fq9Wq8AAWpOd5w+Fwu93OZjNKtoyJYrFIrFcCSDYajdFodDgcptMpEEaMasIRarPZhD2KIs3v9/vBYGAE/nq9drvd6XSSmG63G4ahGC6XSxzH+Cb7GqO32y1NU1Ch1ikwnFqtJkKjLKiVSoUsM1xtsViQZMZ1Xd/3NWz4uIW64dKKGI5QtUAuQEJzzxhUanfK5XKZvA7nOM5PgM5JcL1eeSkTsh8+YhAG2+9YYmy1Wu12WxuIWj7rwpAfStTn8xnFwKvp/wWgooFSjtrr9SaTifbQEpIBu/kaDYR/AgwA6vHyMbSkDjUAAAAASUVORK5CYII=");}
.contract-list-info > p > span.icon-name {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNENUUyODFBMjExODExRThBRTlEOTU0NjE0ODhCQjQ1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNENUUyODFCMjExODExRThBRTlEOTU0NjE0ODhCQjQ1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0Q1RTI4MTgyMTE4MTFFOEFFOUQ5NTQ2MTQ4OEJCNDUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0Q1RTI4MTkyMTE4MTFFOEFFOUQ5NTQ2MTQ4OEJCNDUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4UpheOAAABNklEQVR42kyRza3CMBCEE8dBiaiEAkBBIreUQBXUgJAQnCJxoh8iCohohDsQ8vM+e54s9rBa786Mx+t4mqZhGG63W9u2n88njuNxHKMomnxkWfb9fo0xm80mYkDrfr+/Xi/VvwGO/H6/j8ejBdQ0TZIkZLroUcNBvu/7PM+Xy2VVVQg76H6/T9MUHGNlCKAZd11X1zVQTFpm1trr9fp8PtETaLvdLhaL0+mEilzRtxrvdjsK+eOIHhlc7CPy4VSdZWu5ixoCZlgFaPkBJIKDHg4HySjgzGazcDyfz4MPI/tijz7AabXaLqDEh+Hq0NWlwasIALRgIyW50aZY5+/jOGJ9Pp//GwgEMjLhe8V/PB6r1cotiy/lV4IH+REfSZjr9dpJlGV5uVyosB886KEqiqIQ80+AAQBw5g81H6OssQAAAABJRU5ErkJggg==");}
.contract-list-info > p > span.icon-type {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjM4OTE4Rjg5MjExODExRThCOTA0OEM4ODM3QUUxREMwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjM4OTE4RjhBMjExODExRThCOTA0OEM4ODM3QUUxREMwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Mzg5MThGODcyMTE4MTFFOEI5MDQ4Qzg4MzdBRTFEQzAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Mzg5MThGODgyMTE4MTFFOEI5MDQ4Qzg4MzdBRTFEQzAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz64qOvfAAABh0lEQVR42jyRzQoBcRTF5+PPFPlY2KhhhSdA8QjWSql5Pmx4ABspUcqCshGWlESR7zF+M7fcxfS/d84599x79eFwOBqNns+npmm6rieTyWaz6bpup9M5Ho9KKc/zwuFwtVpV4EqlUjabtSwLQr/fn81m0EgdxzEMA+h2u51MJup2u2UymXw+rwUxnU4fjwcykUgkl8tJ8fP50NwIhUL/HAHTNFF6v9+gv9+vFwQYUl+fElBs4RXCn0ydCgCsv14vFYvFxuPxYrEQ0G63w08ikRgMBt1uFyicy+WSSqX0w+GAP6g0BQqoUqmgR/F0OqFHN9DFYlFJCzHkBiFKMMWYVBjATKfT7EgIGFoulyD2+z1LxJu4JJ3P5woftVqtUCiIUq/Xu16v+LZtu16vy11Wq1W73fY3QCK98HC/31GinfThKwYA+FAjCJRA+/sLLiR12RfL9ufjxd0Yk4Qf+InH4xB4bDYb0PDX63U0GtWxzwqZDCpembLRaMBptVrn81kGYL5yufwTYADmgyNXaHLRiAAAAABJRU5ErkJggg==");}
.contract-list-info > p > span.icon-num {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQxODI5NkRBMjExODExRThCODQ2RDM1Qjc1RkI5ODkzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQxODI5NkRCMjExODExRThCODQ2RDM1Qjc1RkI5ODkzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDE4Mjk2RDgyMTE4MTFFOEI4NDZEMzVCNzVGQjk4OTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDE4Mjk2RDkyMTE4MTFFOEI4NDZEMzVCNzVGQjk4OTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5PQ2jJAAABvklEQVR42iSSx4oqYRCFu9se3SgqZh0MGMGAEcSFj6nMm7gWBHFhGBHBzCij3jEhBhgM9xu7VlWnz1916lSLj8fj+XwKgrDdbvv9/mg02mw2oiiaTKZAIBCJREgoIYjwYH9+ftbrdY/Hk06nbTYbyM/PT7PZ/Pr6KhQK0WgUqnC73drt9sfHx3K5VJ4pcb/fKQFLpVK326UUGFcul7+/v/lwuVxA/72i0+lcr1fA9XoNAURmtM/nczgcTNBoNLvdbjgcSpKk1WpjsRig1WpFWK/XkyaTSTKZBGLE+XxG6GKxAHx/f6fr31xByGQyINJ+v7dYLIoP8/l8MBjIskz78Xg8m80U3Gw2M00mYxwQDK/Xa7fbq9UqSD6fV6vVb29vEMRXyNiGZAT9/v6yE0JpALVSqQSDQbTBZjOj0Si53W7MQpBKpWK5cDhsMBh0Ol0oFOI9b/jUarWgSYlEYjqdYjhU6lwu53Q6XS5XNptlccDVaoXov9U5AX4pzj1fcTqdjsejkuM3J8BjlhGVq2BbrVbj6PF4HL9Ygl+i0WjgUbFY5LAoERXnYB8OB9ojhgQEuX6/P5VK6fV6RfF/AQYAINg4eXQRmnsAAAAASUVORK5CYII=");}
.contract-list-info > p > span + span[class^=icon] {margin-left: 30px;}

.contract-action > p a {color: #000;text-decoration: none;}
.contract-action > p a:hover {color: var(--cMain);}
.fname{
    display: inline-block;
    background: #f2f2f2;
    color: #F28619;
    padding: 0 4px;
    margin-right: 4px;
}
.view a{
    text-decoration: none;
    color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/List.vue